<div [class.workspace-page]="!inline" [class.workspace-page--full]="!inline" [class.workspace-page__panel--card]="!inline" class="br-compact-page">
  <header class="workspace-page__heading" *ngIf="!inline || isView">
    <h1 *ngIf="!inline" class="workspace-page__title">{{ title }}</h1>
    <div class="workspace-page__title-actions">
      <button *ngIf="!inline" type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
              (click)="back()">
        <br-icon>arrow_back</br-icon> Back to Customers
      </button>
      <button *ngIf="isView && auth.hasPermission('Customer.Manage')" type="button"
              class="br-btn br-btn--outline-secondary br-btn--sm"
              (click)="edit()">
        <br-icon>edit</br-icon> Edit
      </button>
    </div>
  </header>

  <app-customer-profile-editor [class.workspace-page__panel]="!inline"
    [mode]="mode"
    [customerId]="customerId" [inline]="inline"
    (profileLoaded)="profileLoaded.emit($event)"
    (completed)="mode = 'view'" (cancelled)="mode = 'view'"></app-customer-profile-editor>
</div>
